export const getLabStatusColor = (status: string): string => {
    const colors: Record<string, string> = {
        received: 'bg-blue-100 text-blue-800',
        queued: 'bg-yellow-100 text-yellow-800',
        testing: 'bg-purple-100 text-purple-800',
        analysis: 'bg-indigo-100 text-indigo-800',
        complete: 'bg-green-100 text-green-800',
        on_hold: 'bg-gray-100 text-gray-800',
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
};

export const getLabPriorityColor = (priority: string): string => {
    const colors: Record<string, string> = {
        critical: 'bg-red-100 text-red-800 border-red-300',
        high: 'bg-orange-100 text-orange-800 border-orange-300',
        medium: 'bg-amber-100 text-amber-800 border-amber-300',
        low: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    };
    return colors[priority] || 'bg-gray-100 text-gray-800 border-gray-300';
};
